import { render } from "./RefferalsDetailview.vue?vue&type=template&id=478c24dd&scoped=true"
import script from "./RefferalsDetailview.vue?vue&type=script&lang=js"
export * from "./RefferalsDetailview.vue?vue&type=script&lang=js"

import "./RefferalsDetailview.vue?vue&type=style&index=0&id=478c24dd&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-478c24dd"]])

export default __exports__